import {t} from '../../../../common/getTranslations';
import {getPeriodText} from '../../../../common/shared/utils/getPeriodText';
import {
  ContentAgeGrade,
  createContentAgeGrade,
} from '../../../../graphql/factory/ContentAgeGrade';
import {
  AgeGrade,
  Bm,
  ContentHomeBadgeType,
  ContentHomeLabelBadge,
  Maybe,
  OnIssue,
} from '../../../../graphql/generated/types';
import {getDisplayWaitfreePeriodByMinute} from '../history/ticket/util/getDisplayWaitfreePeriodByMinute';
import {getContentHomeWaitfreeBadgeType} from './getContentHomeWaitfreeBadgeType';

export function createContentHomeLabelBadge({
  bm,
  ageGrade,
  selfCensorship,
  onIssue,
  pubPeriod,
  waitfreePeriodByMinute,
  chargedPeriodByMinute,
}: {
  bm?: Maybe<Bm>;
  ageGrade?: AgeGrade;
  selfCensorship?: Maybe<boolean>;
  onIssue?: Maybe<OnIssue>;
  pubPeriod?: Maybe<string>;
  waitfreePeriodByMinute?: Maybe<number>;
  chargedPeriodByMinute?: Maybe<number>;
}): ContentHomeLabelBadge[] {
  const contentAgeGrade = createContentAgeGrade(
    ageGrade,
    selfCensorship ?? false
  );

  const displayPeriodByMinute = getDisplayWaitfreePeriodByMinute({
    chargedPeriodByMinute,
    waitfreePeriodByMinute,
  });

  return [
    ...(displayPeriodByMinute &&
    (bm === Bm.PayWaitfree || bm === Bm.MixedWaitfree) // 기다무 작품인 경우에만 충전 주기를 노출합니다.
      ? [
          {
            badgeType: getContentHomeWaitfreeBadgeType(waitfreePeriodByMinute),
          },
          {
            badgeType: ContentHomeBadgeType.LabelBadgeWaitInfo,
            label: t('contenthome_badge_wuf_info', {
              values: {value: getPeriodText(displayPeriodByMinute)},
            }),
          },
        ]
      : []),
    ...(onIssue ? [ON_ISSUE_BADGE_TYPE_MAP[onIssue]] : []),
    ...(pubPeriod && onIssue === OnIssue.Ing
      ? [
          {
            badgeType: ContentHomeBadgeType.LabelBadgeDayOfWeek,
            label: pubPeriod,
          },
        ]
      : []),
    ...(ageGrade &&
    // 전체 이용가시 뱃지를 노출하지 않습니다.
    contentAgeGrade !== ContentAgeGrade.All
      ? [AGE_GRADE_BADGE_TYPE_MAP[contentAgeGrade]]
      : []),
  ];
}

const ON_ISSUE_BADGE_TYPE_MAP: {
  [key in OnIssue]: ContentHomeLabelBadge;
} = {
  [OnIssue.Ing]: {
    badgeType: ContentHomeBadgeType.LabelBadgeSaleIng,
    label: t('common_content_ongoing'),
  },
  [OnIssue.Pause]: {
    badgeType: ContentHomeBadgeType.LabelBadgeSaleRest,
    label: t('common_content_rest'),
  },
  [OnIssue.End]: {
    badgeType: ContentHomeBadgeType.LabelBadgeSaleStop,
    label: t('common_content_completed'),
  },
  // PauseLegacy 일 가능성이 있어 휴재로 넣어둡니다.
  [OnIssue.Unknown]: {
    badgeType: ContentHomeBadgeType.LabelBadgeSaleRest,
    label: t('common_content_rest'),
  },
};

const AGE_GRADE_BADGE_TYPE_MAP: {
  [key in ContentAgeGrade]: ContentHomeLabelBadge;
} = {
  [ContentAgeGrade.All]: {
    badgeType: ContentHomeBadgeType.Badge15Static,
  },
  [ContentAgeGrade.Fifteen]: {
    badgeType: ContentHomeBadgeType.Badge15Static,
  },
  [ContentAgeGrade.Nineteen]: {
    badgeType: ContentHomeBadgeType.Badge19Static,
  },
  [ContentAgeGrade.NineteenSelf]: {
    badgeType: ContentHomeBadgeType.Badge19SelfStatic,
  },
};
